(function () {
  'use strict';

  var trigger      = document.getElementById('ai-assistant-trigger');
  var closeBtn     = document.getElementById('ai-assistant-close');
  var panel        = document.getElementById('ai-assistant-panel');
  var messages     = document.getElementById('ai-messages');
  var inputEl      = document.getElementById('ai-input');
  var sendBtn      = document.getElementById('ai-send');
  var suggestEl    = document.getElementById('ai-suggestions');
  var tabChat      = document.getElementById('ai-tab-chat');
  var tabFinder    = document.getElementById('ai-tab-finder');
  var paneChat     = document.getElementById('ai-pane-chat');
  var paneFinder   = document.getElementById('ai-pane-finder');
  var finderWrap   = document.getElementById('ai-finder');
  var finderContent= document.getElementById('ai-finder-content');

  if (!trigger || !panel) return;

  var isOpen         = false;
  var selFace        = null;
  var selPhoto       = null;
  var userImgB64     = null;
  var userImgMime    = 'image/jpeg';
  var curStep        = 1;

  /* ─────────────────────────────
     Panel — FIX #1: use mousedown + stopPropagation on panel
  ───────────────────────────── */
  function openPanel() {
    isOpen = true;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    var dot = trigger.querySelector('.ai-assistant__tab-dot');
    if (dot) dot.style.display = 'none';
    if (finderContent && !finderContent.innerHTML.trim()) renderFinderStep(1);
  }
  function closePanel() {
    isOpen = false;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    var dot = trigger.querySelector('.ai-assistant__tab-dot');
    if (dot) dot.style.display = '';
  }

  /* stop ALL clicks inside panel from reaching document */
  panel.addEventListener('click', function (e) { e.stopPropagation(); });
  panel.addEventListener('mousedown', function (e) { e.stopPropagation(); });

  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    isOpen ? closePanel() : openPanel();
  });
  closeBtn && closeBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    closePanel();
  });

  /* close only when clicking truly outside */
  document.addEventListener('click', function () {
    if (isOpen) closePanel();
  });

  /* ─────────────────────────────
     Tab switching
  ───────────────────────────── */
  function switchTab(t) {
    var toChat = (t === 'chat');
    paneChat   && paneChat.classList.toggle('is-active', toChat);
    paneFinder && paneFinder.classList.toggle('is-active', !toChat);
    tabChat    && tabChat.classList.toggle('is-active', toChat);
    tabFinder  && tabFinder.classList.toggle('is-active', !toChat);
    tabChat    && tabChat.setAttribute('aria-selected', String(toChat));
    tabFinder  && tabFinder.setAttribute('aria-selected', String(!toChat));
    if (!toChat && finderContent && !finderContent.innerHTML.trim()) renderFinderStep(1);
  }
  tabChat   && tabChat.addEventListener('click',   function () { switchTab('chat'); });
  tabFinder && tabFinder.addEventListener('click', function () { switchTab('finder'); });

  /* ─────────────────────────────
     Chat
  ───────────────────────────── */
  var KB = {
    shipping: 'We deliver in <strong>2 to 4 business days</strong>. Cash on delivery is available — pay when your order arrives.',
    exchange: 'We accept exchanges within <strong>2 days</strong> if the product has a defect or issue. Items must be in original condition.',
    payment:  'We accept <strong>Cash on Delivery</strong> across Egypt. No card needed — just pay when your order arrives.',
    recommend:'Our bestsellers right now:<br>• <strong>Aviator</strong> — timeless, suits most face shapes<br>• <strong>Cat-Eye</strong> — bold and iconic<br>• <strong>Wayfarer</strong> — classic everyday<br>• <strong>Round</strong> — retro-chic',
    tryon:    "Yes! Our representative will bring the frames to your home. Try them on — if they don't suit you, return them on the spot. You only pay the shipping fee.",
    police:   'The Police collection has the latest Aviator and Wayfarer styles at great prices. <a href="/collections/police" style="color:var(--c-gold-light)">Browse the full collection →</a>',
    order:    'You can order multiple products in one order — just add them to your cart and checkout. Everything arrives in one delivery.',
    default:  "Great question! For more help reach out on WhatsApp, or try the <strong>Frame Finder</strong> tab to get matched to your perfect frame 😊"
  };

  function getAnswer(q) {
    q = q.toLowerCase();
    if (/ship|deliver|days|time|fast|arriv|when/.test(q))               return KB.shipping;
    if (/exchang|return|swap|defect|refund|problem|issue/.test(q))      return KB.exchange;
    if (/face|shape|round|oval|square|heart|fit|suit|choose|frame|recommend|which/.test(q)) return 'finder';
    if (/pay|payment|cash|card|cod|money/.test(q))                      return KB.payment;
    if (/multiple|more than one|two|several|bulk/.test(q))              return KB.order;
    if (/try|home|representative|bring|visit/.test(q))                  return KB.tryon;
    if (/police|brand/.test(q))                                         return KB.police;
    return KB.default;
  }

  function addMsg(text, role) {
    var d = document.createElement('div');
    d.className = 'ai-msg ai-msg--' + role;
    d.innerHTML = text;
    messages.appendChild(d);
    messages.scrollTop = messages.scrollHeight;
    return d;
  }
  function addBackBtn(msgEl) {
    var b = document.createElement('button');
    b.className = 'ai-assistant__back-btn';
    b.type = 'button';
    b.innerHTML = '← Ask another question';
    b.addEventListener('click', function () {
      messages.innerHTML = '<div class="ai-msg ai-msg--ai">Hey! I\'m your personal CATCHY stylist. Ask me anything or try <strong>Frame Finder</strong> 👆</div>';
      if (suggestEl) suggestEl.style.display = '';
    });
    /* insert as sibling AFTER the message, not inside it */
    if (msgEl && msgEl.parentNode) {
      msgEl.parentNode.insertBefore(b, msgEl.nextSibling);
    } else {
      messages.appendChild(b);
    }
    messages.scrollTop = messages.scrollHeight;
  }
  function showTyping() {
    var t = document.createElement('div');
    t.className = 'ai-typing'; t.id = 'ai-typing-indicator';
    t.innerHTML = '<span></span><span></span><span></span>';
    messages.appendChild(t);
    messages.scrollTop = messages.scrollHeight;
  }
  function removeTyping() {
    var t = document.getElementById('ai-typing-indicator');
    if (t) t.remove();
  }
  function sendMessage(text) {
    text = text.trim(); if (!text) return;
    if (inputEl) inputEl.value = '';
    if (suggestEl) suggestEl.style.display = 'none';
    addMsg(text, 'user');
    showTyping();
    setTimeout(function () {
      removeTyping();
      var ans = getAnswer(text);
      if (ans === 'finder') {
        var finderMsg = addMsg('Opening Frame Finder for you! 📸', 'ai');
        addBackBtn(finderMsg);
        setTimeout(function () { switchTab('finder'); }, 500);
      } else {
        addBackBtn(addMsg(ans, 'ai'));
      }
    }, 700 + Math.random() * 400);
  }

  sendBtn && sendBtn.addEventListener('click', function () { sendMessage(inputEl ? inputEl.value : ''); });
  inputEl && inputEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(inputEl.value); }
  });
  suggestEl && suggestEl.addEventListener('click', function (e) {
    var btn = e.target.closest('.ai-suggestion');
    if (!btn) return;
    if (btn.dataset.action === 'finder') {
      suggestEl.style.display = 'none';
      addMsg('How do I choose frames for my face?', 'user');
      showTyping();
      setTimeout(function () {
        removeTyping();
        var finderMsg = addMsg('Opening Frame Finder for you! 📸', 'ai');
        addBackBtn(finderMsg);
        setTimeout(function () { switchTab('finder'); }, 500);
      }, 700);
    } else {
      sendMessage(btn.dataset.suggestion || btn.textContent.trim());
    }
  });

  /* ─────────────────────────────
     Frame Finder data
  ───────────────────────────── */
  var FL = { oval:'Oval', round:'Round', square:'Square', heart:'Heart' };
  var FD = { oval:'Balanced', round:'Full cheeks', square:'Strong jaw', heart:'Wide brow' };
  var FSVG = {
    oval:   '<ellipse cx="14" cy="17" rx="9" ry="13"/>',
    round:  '<ellipse cx="14" cy="17" rx="11" ry="11"/>',
    square: '<rect x="2" y="4" width="24" height="26" rx="2"/>',
    heart:  '<path d="M14 30 C14 30 1 20 1 10 C1 4 7 1 14 7 C21 1 27 4 27 10 C27 20 14 30 14 30Z"/>'
  };
  var FSVG_LG = {
    oval:   '<ellipse cx="22" cy="27" rx="15" ry="21"/>',
    round:  '<ellipse cx="22" cy="27" rx="19" ry="19"/>',
    square: '<rect x="5" y="7" width="34" height="40" rx="3"/>',
    heart:  '<path d="M22 46 C22 46 3 33 3 17 C3 8 11 4 22 12 C33 4 41 8 41 17 C41 33 22 46 22 46Z"/>'
  };
  var RECS = {
    oval:  { pct:96, tip:'Versatile — most styles work.',         frames:[{t:'aviator',n:'Aviator',s:5,best:true},{t:'wayfarer',n:'Wayfarer',s:5},{t:'cateye',n:'Cat-Eye',s:4},{t:'round',n:'Round',s:4},{t:'rectangle',n:'Rectangle',s:4},{t:'browline',n:'Browline',s:3}] },
    round: { pct:94, tip:'Angular frames add definition.',        frames:[{t:'rectangle',n:'Rectangle',s:5,best:true},{t:'square',n:'Square',s:5},{t:'wayfarer',n:'Wayfarer',s:4},{t:'browline',n:'Browline',s:4},{t:'aviator',n:'Aviator',s:3},{t:'geometric',n:'Geometric',s:3}] },
    square:{ pct:92, tip:'Round frames soften your jaw.',         frames:[{t:'round',n:'Round',s:5,best:true},{t:'oval',n:'Oval',s:5},{t:'aviator',n:'Aviator',s:4},{t:'cateye',n:'Cat-Eye',s:3},{t:'geometric',n:'Geometric',s:3},{t:'browline',n:'Browline',s:2}] },
    heart: { pct:95, tip:'Bottom-heavy frames balance your brow.',frames:[{t:'round',n:'Round',s:5,best:true},{t:'oval',n:'Oval',s:5},{t:'aviator',n:'Aviator',s:4},{t:'browline',n:'Browline',s:4},{t:'wayfarer',n:'Wayfarer',s:3},{t:'rectangle',n:'Rectangle',s:2}] }
  };

  /* ─────────────────────────────
     Frame Finder steps
  ───────────────────────────── */
  function setPills(n) {
    if (!finderWrap) return;
    finderWrap.querySelectorAll('.ai-finder__pill').forEach(function (p) {
      var s = parseInt(p.dataset.step);
      p.classList.toggle('is-active', s === n);
      p.classList.toggle('is-done',   s < n);
    });
  }
  function renderFinderStep(n) {
    if (!finderContent) return;
    curStep = n; setPills(n);
    if (n === 1) finderContent.innerHTML = stepPhoto();
    else if (n === 2) finderContent.innerHTML = stepFace();
    else if (n === 3) buildResults();
  }

  /* delegated clicks inside finder */
  finderContent && finderContent.addEventListener('click', function (e) {
    /* photo card selection */
    var photoCard = e.target.closest('.ai-finder__photo[data-face]');
    if (photoCard) {
      finderContent.querySelectorAll('.ai-finder__photo').forEach(function (x) { x.classList.remove('is-active'); });
      photoCard.classList.add('is-active');
      selPhoto = photoCard.dataset.face;
      var ab = document.getElementById('ai-finder-analyze');
      if (ab) ab.disabled = false;
      return;
    }
    /* analyze */
    if (e.target.closest('#ai-finder-analyze')) { doAnalyze(); return; }
    /* confirm after detection */
    if (e.target.closest('#ai-finder-to2')) { renderFinderStep(2); return; }
    /* face card */
    var fc = e.target.closest('.ai-finder__face[data-f]');
    if (fc) {
      finderContent.querySelectorAll('.ai-finder__face').forEach(function (x) { x.classList.remove('is-active'); });
      fc.classList.add('is-active');
      selFace = fc.dataset.f;
      return;
    }
    /* confirm step 2 */
    if (e.target.closest('#ai-finder-confirm')) { renderFinderStep(3); return; }
    /* back */
    if (e.target.closest('#ai-finder-back2')) { renderFinderStep(1); return; }
    /* restart */
    if (e.target.closest('#ai-finder-restart')) {
      selFace = null; selPhoto = null; userImgB64 = null;
      renderFinderStep(1); return;
    }
  });

  /* file upload */
  finderContent && finderContent.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'ai-photo-upload') {
      var file = e.target.files[0];
      if (!file) return;
      userImgMime = file.type || 'image/jpeg';
      var reader = new FileReader();
      reader.onload = function (ev) {
        var dataURL = ev.target.result;
        userImgB64 = dataURL.split(',')[1];
        var preview     = document.getElementById('ai-upload-preview');
        var placeholder = document.getElementById('ai-upload-placeholder');
        var analyzeBtn  = document.getElementById('ai-finder-analyze');
        if (preview)     { preview.src = dataURL; preview.style.display = 'block'; }
        if (placeholder)   placeholder.style.display = 'none';
        if (analyzeBtn)    analyzeBtn.disabled = false;
        selPhoto = 'uploaded';
      };
      reader.readAsDataURL(file);
    }
  });

  /* ─────────────────────────────
     Step 1 — photo HTML
  ───────────────────────────── */
  function stepPhoto() {
    var shapes = ['oval','round','square','heart'];
    return (
      '<div class="ai-finder__title">Upload your photo</div>' +
      '<div class="ai-finder__sub">Upload a front-facing photo for AI detection — or pick a face shape manually</div>' +
      '<label class="ai-finder__upload-box" for="ai-photo-upload">' +
        '<img id="ai-upload-preview" src="" alt="" style="display:none;width:100%;border-radius:4px;max-height:130px;object-fit:cover;">' +
        '<div id="ai-upload-placeholder">' +
          '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--c-gold-light)" stroke-width="1.5" style="display:block;margin:0 auto 6px">' +
            '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/>' +
          '</svg>' +
          '<div style="font-size:0.75rem;color:var(--c-charcoal)">Tap to upload photo</div>' +
          '<div style="font-size:0.625rem;color:var(--c-mid-gray);margin-top:2px">JPG or PNG · front-facing</div>' +
        '</div>' +
        '<input type="file" id="ai-photo-upload" accept="image/*" style="position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%;">' +
      '</label>' +
      '<div class="ai-finder__or-divider"><span>or choose manually</span></div>' +
      '<div class="ai-finder__photo-grid">' +
        shapes.map(function (f) {
          return (
            '<div class="ai-finder__photo" data-face="' + f + '">' +
              '<div class="ai-finder__photo-ck"><svg width="8" height="8" viewBox="0 0 10 10" fill="none" stroke="#111110" stroke-width="2.5"><polyline points="1,5 4,8 9,2"/></svg></div>' +
              '<svg viewBox="0 0 28 34" fill="none" width="34" height="42" style="display:block" stroke="var(--c-mid-gray)" stroke-width="1.5">' + FSVG[f] + '</svg>' +
              '<div class="ai-finder__photo-label">' + FL[f] + '</div>' +
            '</div>'
          );
        }).join('') +
      '</div>' +
      '<button class="ai-finder__btn" id="ai-finder-analyze" disabled type="button">Analyze →</button>'
    );
  }

  /* ─────────────────────────────
     FIX #2 — Real AI face detection via Claude API
  ───────────────────────────── */
  function doAnalyze() {
    var isRealPhoto = (userImgB64 !== null);

    finderContent.innerHTML =
      '<div class="ai-finder__analyzing">' +
        '<div class="ai-finder__spin"></div>' +
        '<p>' + (isRealPhoto ? 'Analyzing your photo with AI…' : 'Analyzing face shape…') + '</p>' +
        (isRealPhoto ? '<p style="color:var(--c-gold-light);font-size:0.75rem;margin-top:4px">Detecting facial landmarks</p>' : '') +
      '</div>';

    if (isRealPhoto) {
      detectFaceWithAI();
    } else {
      /* manual selection — instant */
      setTimeout(function () {
        selFace = selPhoto;
        showDetectedResult();
      }, 1400);
    }
  }

  function detectFaceWithAI() {
    fetch('https://api.anthropic.com/v1/messages', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        model: 'claude-opus-4-5',
        max_tokens: 50,
        messages: [{
          role: 'user',
          content: [
            {
              type: 'image',
              source: { type: 'base64', media_type: userImgMime, data: userImgB64 }
            },
            {
              type: 'text',
              text: 'Look at this person\'s face shape carefully. Classify it as exactly one of: oval, round, square, or heart. Consider: oval = balanced proportions, slightly wider at cheekbones; round = similar width and length, full cheeks; square = strong jaw, wide forehead, angular; heart = wide forehead, narrow chin, V-shaped jaw. Reply with ONLY the single word — no punctuation, no explanation.'
            }
          ]
        }]
      })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      var raw = '';
      if (data.content && data.content[0] && data.content[0].text) {
        raw = data.content[0].text.trim().toLowerCase();
      }
      var valid = ['oval','round','square','heart'];
      selFace = valid.indexOf(raw) !== -1 ? raw : 'oval';
      showDetectedResult();
    })
    .catch(function () {
      /* fallback to oval on error */
      selFace = 'oval';
      showDetectedResult();
    });
  }

  function showDetectedResult() {
    var previewHTML = userImgB64
      ? '<div style="margin-bottom:0.75rem;border-radius:4px;overflow:hidden;border:1px solid var(--c-light-gray)">' +
          '<img src="data:' + userImgMime + ';base64,' + userImgB64 + '" style="width:100%;display:block;max-height:120px;object-fit:cover" alt="Your photo">' +
        '</div>'
      : '';

    finderContent.innerHTML =
      previewHTML +
      '<div class="ai-finder__detected">' +
        '<div class="ai-finder__detected-ic">✓</div>' +
        '<div>' +
          '<div style="font-size:0.8125rem;font-weight:500;color:#085041">' + FL[selFace] + ' face detected!</div>' +
          '<div style="font-size:0.7rem;color:#0F6E56;margin-top:2px">' + (userImgB64 ? 'AI analysis complete' : 'Manual selection') + '</div>' +
        '</div>' +
      '</div>' +
      '<p style="font-size:0.8125rem;color:var(--c-charcoal);margin-top:0.75rem;line-height:1.55">We identified your face as <strong>' + FL[selFace] + '</strong>. Confirm or change below.</p>' +
      '<button class="ai-finder__btn" id="ai-finder-to2" type="button">Confirm →</button>';
  }

  /* ─────────────────────────────
     Step 2 — face confirmation
  ───────────────────────────── */
  function stepFace() {
    var shapes = ['oval','round','square','heart'];
    return (
      '<div class="ai-finder__title">Confirm your face shape</div>' +
      '<div class="ai-finder__sub">Detected: <strong style="color:var(--c-gold-light)">' + FL[selFace || 'oval'] + '</strong> — tap to change</div>' +
      '<div class="ai-finder__face-grid">' +
        shapes.map(function (f) {
          return (
            '<div class="ai-finder__face ' + (f === (selFace || 'oval') ? 'is-active' : '') + '" data-f="' + f + '">' +
              '<div class="ai-finder__face-ck"><svg width="7" height="7" viewBox="0 0 10 10" fill="none" stroke="#111110" stroke-width="2.5"><polyline points="1,5 4,8 9,2"/></svg></div>' +
              '<svg viewBox="0 0 28 34" fill="none" width="28" height="32" style="display:block;margin:0 auto 5px" stroke="var(--c-black)" stroke-width="1.5">' + FSVG[f] + '</svg>' +
              '<div class="ai-finder__face-name">' + FL[f] + '</div>' +
              '<div class="ai-finder__face-desc">' + FD[f] + '</div>' +
            '</div>'
          );
        }).join('') +
      '</div>' +
      '<button class="ai-finder__btn" id="ai-finder-confirm" type="button">See my matches →</button>' +
      '<button class="ai-finder__btn ai-finder__btn--sec" id="ai-finder-back2" type="button">← Back</button>'
    );
  }

  /* ─────────────────────────────
     Frame SVG helper
  ───────────────────────────── */
  function frameSVG(type, w, h) {
    w = w || 66; h = h || 30;
    var fc = '#d4d0c8', s = '#111110';
    var sh = {
      round:     '<ellipse cx="22" cy="19" rx="15" ry="14" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><ellipse cx="58" cy="19" rx="15" ry="14" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><line x1="37" y1="19" x2="43" y2="19" stroke="'+s+'" stroke-width="2"/><line x1="4" y1="15" x2="7" y2="17" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/><line x1="76" y1="15" x2="73" y2="17" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/>',
      cateye:    '<path d="M7 23 Q10 10 28 9 Q37 9 38 19 Q37 27 22 28 Q10 28 7 23Z" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><path d="M42 23 Q45 10 63 9 Q72 9 73 19 Q72 27 58 28 Q46 28 42 23Z" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><line x1="38" y1="19" x2="42" y2="19" stroke="'+s+'" stroke-width="2"/><line x1="4" y1="17" x2="7" y2="19" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/><line x1="76" y1="17" x2="73" y2="19" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/>',
      rectangle: '<rect x="6" y="11" width="30" height="18" rx="3" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><rect x="44" y="11" width="30" height="18" rx="3" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><line x1="36" y1="20" x2="44" y2="20" stroke="'+s+'" stroke-width="2"/><line x1="3" y1="15" x2="6" y2="17" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/><line x1="77" y1="15" x2="74" y2="17" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/>',
      wayfarer:  '<path d="M7 15 Q8 9 22 9 Q34 9 36 16 Q36 27 22 28 Q8 28 7 15Z" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><path d="M44 15 Q45 9 58 9 Q72 9 73 16 Q73 27 58 28 Q44 28 44 15Z" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><line x1="36" y1="19" x2="44" y2="19" stroke="'+s+'" stroke-width="2"/><line x1="3" y1="14" x2="7" y2="16" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/><line x1="77" y1="14" x2="73" y2="16" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/>',
      square:    '<rect x="6" y="10" width="30" height="20" rx="5" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><rect x="44" y="10" width="30" height="20" rx="5" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><line x1="36" y1="20" x2="44" y2="20" stroke="'+s+'" stroke-width="2"/><line x1="3" y1="14" x2="6" y2="17" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/><line x1="77" y1="14" x2="74" y2="17" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/>',
      aviator:   '<path d="M8 13 Q10 8 22 9 Q30 9 34 15 Q36 21 28 27 Q20 31 12 27 Q6 22 8 13Z" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><path d="M46 13 Q48 8 58 9 Q68 9 72 15 Q74 21 66 27 Q58 31 50 27 Q44 22 46 13Z" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><line x1="34" y1="16" x2="46" y2="16" stroke="'+s+'" stroke-width="2"/><line x1="4" y1="12" x2="8" y2="14" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/><line x1="76" y1="12" x2="72" y2="14" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/>',
      geometric: '<path d="M8 19 L14 9 L30 9 L36 19 L30 29 L14 29Z" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><path d="M44 19 L50 9 L66 9 L72 19 L66 29 L50 29Z" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><line x1="36" y1="19" x2="44" y2="19" stroke="'+s+'" stroke-width="2"/><line x1="4" y1="15" x2="8" y2="18" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/><line x1="76" y1="15" x2="72" y2="18" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/>',
      browline:  '<rect x="7" y="9" width="29" height="9" rx="2" fill="'+s+'" stroke="'+s+'" stroke-width="1"/><path d="M8 18 Q8 29 21 29 Q34 29 35 18" fill="'+fc+'" stroke="'+s+'" stroke-width="2"/><rect x="44" y="9" width="29" height="9" rx="2" fill="'+s+'" stroke="'+s+'" stroke-width="1"/><path d="M45 18 Q45 29 58 29 Q71 29 72 18" fill="'+fc+'" stroke="'+s+'" stroke-width="2"/><line x1="35" y1="16" x2="44" y2="16" stroke="'+s+'" stroke-width="2"/><line x1="3" y1="13" x2="7" y2="15" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/><line x1="77" y1="13" x2="73" y2="15" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/>',
      oval:      '<ellipse cx="21" cy="19" rx="14" ry="11" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><ellipse cx="59" cy="19" rx="14" ry="11" fill="'+fc+'" stroke="'+s+'" stroke-width="2.5"/><line x1="35" y1="19" x2="45" y2="19" stroke="'+s+'" stroke-width="2"/><line x1="4" y1="15" x2="7" y2="18" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/><line x1="76" y1="15" x2="73" y2="18" stroke="'+s+'" stroke-width="2" stroke-linecap="round"/>'
    };
    return '<svg viewBox="0 0 80 38" fill="none" xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '">' + (sh[type] || '') + '</svg>';
  }

  /* ─────────────────────────────
     Step 3 — results
  ───────────────────────────── */
  function buildResults() {
    var r = RECS[selFace || 'oval'];
    finderContent.innerHTML = '<div class="ai-finder__loading"><span></span><span></span><span></span> Building your matches…</div>';
    setTimeout(function () {
      var wf = '<svg viewBox="0 0 44 54" fill="none" xmlns="http://www.w3.org/2000/svg" width="50" height="60" stroke="rgba(255,255,255,.6)" stroke-width="1.5">' + FSVG_LG[selFace || 'oval'] + '</svg>';
      var top3 = r.frames.slice(0,3).map(function (fr) {
        return frameSVG(fr.t,52,22).replace(/#d4d0c8/g,'rgba(255,255,255,.8)').replace(/#111110/g,'#fff');
      }).join('');
      var cards = r.frames.map(function (fr) {
        var dots = [1,2,3,4,5].map(function (i) {
          return '<div class="ai-finder__sdot' + (i <= fr.s ? ' is-on' : '') + '"></div>';
        }).join('');
        return (
          '<div class="ai-finder__frame-card' + (fr.best ? ' is-best' : '') + '">' +
            (fr.best ? '<div class="ai-finder__frame-badge">Best</div>' : '') +
            '<div class="ai-finder__frame-img">' + frameSVG(fr.t) + '</div>' +
            '<div class="ai-finder__frame-info">' +
              '<div class="ai-finder__frame-name">' + fr.n + '</div>' +
              '<div class="ai-finder__sdots">' + dots + '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      var previewFace = userImgB64
        ? '<img src="data:' + userImgMime + ';base64,' + userImgB64 + '" style="max-height:60px;width:100%;object-fit:cover;opacity:.8;display:block;" alt="Your photo">'
        : wf;

      finderContent.innerHTML =
        '<div class="ai-finder__preview">' +
          '<div class="ai-finder__preview-face">' + previewFace + '</div>' +
          '<div class="ai-finder__preview-frames">' + top3 + '</div>' +
          '<div class="ai-finder__preview-label">Top 3 frames for your face shape</div>' +
        '</div>' +
        '<div class="ai-finder__res-head">' +
          '<div class="ai-finder__res-title">' + FL[selFace || 'oval'] + ' Face Shape</div>' +
          '<div class="ai-finder__res-tip">' + r.tip + '</div>' +
          '<div class="ai-finder__match-track"><div class="ai-finder__match-fill" id="ai-match-fill"></div></div>' +
          '<div class="ai-finder__match-row"><span>Match quality</span><span id="ai-match-pct">0%</span></div>' +
        '</div>' +
        '<div class="ai-finder__frames-grid">' + cards + '</div>' +
        '<button class="ai-finder__btn ai-finder__btn--sec" id="ai-finder-restart" type="button">← Start over</button>';

      setTimeout(function () {
        var mf = document.getElementById('ai-match-fill');
        var mp = document.getElementById('ai-match-pct');
        if (mf) mf.style.width = r.pct + '%';
        if (mp) mp.textContent = r.pct + '%';
      }, 150);
    }, 900);
  }

  /* init */
  if (finderContent) renderFinderStep(1);

})();
